import * as React from 'react';
import { Layout as AntLayout } from 'antd';

export const Footer = () => <AntLayout.Footer style={{ textAlign: 'center' }}>© {new Date().getFullYear()} ИИшница</AntLayout.Footer>;
